'use client';

// Keep middleware aligned with settled remote gates and immediate engineer
// overrides. Network switches remount analytics; pending initialization must
// not overwrite a known mainnet value before the destination request.
import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { useEffect } from 'react';
import { useFeatureGate } from '@/hooks/use-feature-gate';
import { setCookie } from '@/lib/config/cookies';
import { MAINNET_GATE_COOKIE, MAINNET_GATE_COOKIE_MAX_AGE } from '@/lib/network/gate-cookie';
import { useDevToolkitStore } from '@/stores/dev-toolkit';
export function MainnetGateMirror() {
  const $ = _c(3);
  const override = useDevToolkitStore(_temp);
  const remoteGate = useFeatureGate("mainnet_enabled");
  const resolved = override ?? remoteGate;
  let t0;
  let t1;
  if ($[0] !== resolved) {
    t0 = () => {
      if (resolved === null) {
        return;
      }
      setCookie(MAINNET_GATE_COOKIE, resolved ? "true" : "false", MAINNET_GATE_COOKIE_MAX_AGE);
    };
    t1 = [resolved];
    $[0] = resolved;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
function _temp(s) {
  return s.overrides.mainnet_enabled;
}